import { t } from "@lingui/macro";
import { createNativeStackNavigator } from "@react-navigation/native-stack";
import { RelayEnvironmentProvider } from "react-relay/hooks";

import { useRelayPrivateEnvironment } from "@whoosh/relay/src";

import { LocaleTransitionBoundary } from "../../features/LanguagePreference";
import { useSchemaVersionMismatchHandler } from "../../features/OtaUpdateOverlay";
import { InitialScreen, RegisterScreen, ResetPassword } from "../../screens";
import { SSOErrorScreen } from "../../screens/SSOError";
import { UnauthenticatedNavigatorParamList } from "./types";
import { UnauthenticatedRoutes } from "./unauthenticatedRoutes";

const Stack = createNativeStackNavigator<UnauthenticatedNavigatorParamList>();

type UnauthenticatedStackNavigatorProps = {
  defaultClubSlug?: null | string;
  hasSession: boolean;
};

export const UnauthenticatedStackNavigator = ({
  defaultClubSlug,
  hasSession,
}: UnauthenticatedStackNavigatorProps) => {
  const schemaVersionMismatchHandler = useSchemaVersionMismatchHandler();
  const PrivateEnvironment = useRelayPrivateEnvironment({
    schemaVersionMismatchHandler,
    // A previous staff session must not select the context for a new patron login.
    useStoredStaffContext: false,
  });
  return PrivateEnvironment ? (
    <RelayEnvironmentProvider environment={PrivateEnvironment}>
      <Stack.Navigator initialRouteName={UnauthenticatedRoutes.Initial}>
        <Stack.Screen
          name={UnauthenticatedRoutes.Initial}
          children={() => (
            <LocaleTransitionBoundary>
              <InitialScreen
                defaultClubSlug={defaultClubSlug}
                hasSession={hasSession}
              />
            </LocaleTransitionBoundary>
          )}
          options={{ headerShown: false, title: t`Whoosh` }}
        />
        <Stack.Screen
          name={UnauthenticatedRoutes.Register}
          component={RegisterScreen}
          options={{ headerShown: false, title: t`Whoosh` }}
        />
        <Stack.Screen
          name={UnauthenticatedRoutes.ResetPassword}
          component={ResetPassword}
          options={{ headerShown: false }}
        />
        <Stack.Screen
          name={"SSOError"}
          component={SSOErrorScreen}
          options={{
            title: t`Error`,
            headerShown: false,
          }}
        />
      </Stack.Navigator>
    </RelayEnvironmentProvider>
  ) : null;
};
